/**
 * Functions to safely Base64 encode/decode with Unicode Strings
 * Taken from https://developer.mozilla.org/en-US/docs/Web/API/Window/btoa#unicode_strings
 */

export function base64ToBytes(base64: string): Uint8Array<ArrayBuffer> {
    const binString = atob(base64);
    return Uint8Array.from(binString, (m, k) => m.codePointAt(0) as number);
}

export function bytesToBase64(bytes: Uint8Array<ArrayBuffer>): string {
    const binString = Array.from(bytes, (byte) =>
        String.fromCodePoint(byte),
    ).join('');
    return btoa(binString);
}

export function stringToBase64(input: string): string {
    return bytesToBase64(new TextEncoder().encode(input));
}

export function base64ToString(base64: string): string {
    return new TextDecoder().decode(base64ToBytes(base64));
}
